/**
 * @file     useReltaTrack.ts
 * @purpose  Typed dispatcher for Relta first-party analytics events. Use
 *           alongside useAnalytics() when you want compile-time validation
 *           of event names + payloads against the registry.
 *
 *           Migration: P7 replaces raw-string useAnalytics().trackEvent
 *           callsites with this. Until then, this is opt-in.
 */

'use client';

import { useCallback } from 'react';
import { reltaAnalytics } from '@/services/analytics/relta/client';
import {
  eventRegistry,
  type EventName,
} from '@/services/analytics/relta/events';
import type { z } from 'zod';

type PayloadOf<N extends EventName> = z.input<(typeof eventRegistry)[N]['schema']>;

export function useReltaTrack() {
  return useCallback(
    <N extends EventName>(name: N, payload: PayloadOf<N>) => {
      reltaAnalytics.track(name, (payload ?? {}) as Record<string, unknown>);
    },
    [],
  );
}

export function reltaTrack<N extends EventName>(name: N, payload: PayloadOf<N>) {
  reltaAnalytics.track(name, (payload ?? {}) as Record<string, unknown>);
}
